﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_pictureSlideList from './tpl/pictureSlideList.html';
import View_PictureSlideListItem from './pictureSlideListItem';

export default Marionette.CollectionView.extend({
    tagName: 'ul',
    className: '',
    attributes: function () {
        return {
            id: 'this.animationCube();',
            className: 'div100'
        }
    },
    childViewContainer: '#pictureSlideListItem',
    childView: View_PictureSlideListItem,
    getTemplate: function () {
        return tpl_pictureSlideList();
    },
    ui: {
        'pictureSlideListItem': '#pictureSlideListItem'
    },

    initialize: function () {
        this.app = this.options.app;

    },
    buildChildView: function (child, ChildViewClass, childViewOptions) {
        var options = _.extend({ model: child }, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    },
    onAttach() {
    }

});
